import type { DivisionListResponse } from './api';

export interface DivisionOption {
  label: string;
  value: number;
}

export const normalizeDivisionList = (list: DivisionListResponse): DivisionOption[] => {
  if (!list) {
    return [];
  }

  return list.map((row) => ({
    label: row.divisionDesc,
    value: row.divisionKey,
  }));
};
